import { render } from "./InAppPurchaseSyncIntegrationSettings.vue?vue&type=template&id=0dd047ae"
import script from "./InAppPurchaseSyncIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./InAppPurchaseSyncIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__